import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { sapi } from "../lib/strategy";

const Ctx = createContext(null);
const ROUND_KEY = "st_round";

export function StrategyProvider({ children }) {
  const [me, setMe] = useState(null); // null checking, false anon, obj authed
  const [rounds, setRounds] = useState([]);
  const [roundId, setRoundIdState] = useState(() => localStorage.getItem(ROUND_KEY) || null);
  const [questions, setQuestions] = useState(null);

  useEffect(() => {
    sapi.get("/auth/me").then((r) => setMe(r.data)).catch(() => setMe(false));
  }, []);

  const refreshRounds = useCallback(async () => {
    const { data } = await sapi.get("/rounds");
    setRounds(data);
    return data;
  }, []);

  useEffect(() => {
    if (!me) return;
    refreshRounds();
    sapi.get("/questions").then((r) => setQuestions(r.data));
  }, [me, refreshRounds]);

  useEffect(() => {
    if (!rounds.length) return;
    if (!roundId || !rounds.find((r) => r.id === roundId)) {
      const live = rounds.find((r) => !r.demo && r.status !== "archived") || rounds.find((r) => !r.demo) || rounds[0];
      setRoundIdState(live.id);
      localStorage.setItem(ROUND_KEY, live.id);
    }
  }, [rounds, roundId]);

  const setRoundId = (id) => { localStorage.setItem(ROUND_KEY, id); setRoundIdState(id); };
  const round = useMemo(() => rounds.find((r) => r.id === roundId) || null, [rounds, roundId]);

  const login = async (participant_id, passcode) => {
    const { data } = await sapi.post("/auth/login", { participant_id, passcode });
    setMe(data);
    return data;
  };
  const logout = async () => {
    await sapi.post("/auth/logout");
    setMe(false);
    setRounds([]);
  };

  return <Ctx.Provider value={{ me, setMe, login, logout, rounds, refreshRounds, round, roundId, setRoundId, questions }}>{children}</Ctx.Provider>;
}

export const useStrategy = () => useContext(Ctx);
